// Sets window.process.env while everything moves to window._env_ to stop it from breaking issues
// Should be removed once core and rollbar are fixed

/* eslint-disable */
if (!window?.process?.env) {
  window.process = { env: {} };
}
